import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4 border-b border-gray-200 dark:border-gray-700" }
const _hoisted_2 = {
  class: "flex flex-wrap -mb-px text-sm font-medium text-center",
  id: "myTab",
  "data-tabs-toggle": "#myTabContent",
  role: "tablist"
}
const _hoisted_3 = {
  class: "mr-2",
  role: "presentation"
}
const _hoisted_4 = ["aria-selected"]
const _hoisted_5 = {
  class: "mr-2",
  role: "presentation"
}
const _hoisted_6 = ["aria-selected"]
const _hoisted_7 = {
  class: "mr-2",
  role: "presentation"
}
const _hoisted_8 = ["aria-selected"]
const _hoisted_9 = { id: "myTabContent" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800",
  id: "order",
  role: "tabpanel",
  "aria-labelledby": "order-tab"
}, " Commandes in progress... ", -1)
const _hoisted_11 = {
  class: "hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800",
  id: "shippingMethod",
  role: "tabpanel",
  "aria-labelledby": "shippingMethod-tab"
}
const _hoisted_12 = {
  class: "hidden p-4 rounded-lg bg-gray-50 dark:bg-gray-800",
  id: "backOffice",
  role: "tabpanel",
  "aria-labelledby": "backOffice-tab"
}

import { initFlowbite } from 'flowbite'
import { onMounted, ref, watch } from "vue";
import PageShippingMethod from "@/views/admin/supplier/shippingMethod/PageShippingMethod.vue";
import BackOfficeSupplierList from "@/views/admin/supplier/backOfficeSupplier/BackOfficeSupplierList.vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'SupplierDetail',
  setup(__props) {

const route = useRoute();
const reloadKey = ref(0);
const ariaSelectedFromUrl = route.params.ariaSelected ? route.params.ariaSelected.toString() : "1";
const ariaSelected = (index) => {
  return index.toString() === ariaSelectedFromUrl.toString();
}

const reloadChildComponent = () => {
  reloadKey.value += 1;
}
const supplierUuid = ref<string>("");
const redirectToLegacySupplier = () => {
    window.location.href = `${process.env.VUE_APP_LEGACY_URL}admin/suppliers/${supplierUuid.value}/orders`;
}
onMounted(() => {
  supplierUuid.value = route.params.uuid as string;
  initFlowbite();
})

watch(() => route.fullPath, () => {
  reloadChildComponent();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("button", {
            class: "inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
            id: "shippingMethod-tab",
            "data-tabs-target": "#shippingMethod",
            type: "button",
            role: "tab",
            "aria-controls": "shippingMethod",
            "aria-selected": ariaSelected('1')
          }, "Moyens d'expédition", 8, _hoisted_4)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("button", {
            class: "inline-block p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300",
            id: "backOffice-tab",
            "data-tabs-target": "#backOffice",
            type: "button",
            role: "tab",
            "aria-controls": "backOffice",
            "aria-selected": ariaSelected('2')
          }, "Utilisateurs du Back-office", 8, _hoisted_6)
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectToLegacySupplier())),
            class: "inline-block p-4 border-b-2 rounded-t-lg",
            id: "order-tab",
            "data-tabs-target": "#order",
            type: "button",
            role: "tab",
            "aria-controls": "order",
            "aria-selected": ariaSelected('3')
          }, "Commandes", 8, _hoisted_8)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(), _createBlock(PageShippingMethod, {
          key: `${reloadKey.value}`
        }))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(), _createBlock(BackOfficeSupplierList, {
          key: `${reloadKey.value}`
        }))
      ])
    ])
  ], 64))
}
}

})